import { formatISODate } from '@pidz/date';
import { ShiftStatus } from '@pidz/enums';
import { DateTime } from 'luxon';
import { createFilterStore } from './filterFactory';

export default createFilterStore<IShiftFilterParams>('shiftFilter', {
  date: {
    start: formatISODate(DateTime.now()) || '',
    end: '',
  },
  shiftStatuses: [ShiftStatus.RESERVED, ShiftStatus.FILLED],
  functions: [],
  dayParts: [],
  travelTime: 0,
  alreadyWorkedAt: 0,
});
